import { useEffect } from "react";
import { PlayerExternalState } from "./useExternalState/useExternalState";
import * as Tone from "tone";
import { SynthType } from "./useSynths";
import { Props as VolumeSliderProps } from "ui/atoms/VolumeSlider";

interface Params {
  state: PlayerExternalState;
  // it is a func to prevent synths from being created on the server
  synths: () => {
    [synth in SynthType]: Tone.Sampler | Tone.MembraneSynth;
  };
}

export const volumeSliderProps: Pick<
  VolumeSliderProps,
  "min" | "max" | "steps"
> = {
  min: -40,
  max: 0,
  steps: 2,
};

export default function useSyncSynthsWithExternalState({
  state,
  synths,
}: Params) {
  useEffect(() => {
    Object.entries(synths()).forEach(([_key, synth]) => {
      const key = _key as SynthType;

      synth.volume.value = state.volume[key];
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.volume]);
}
